import { API } from 'aws-amplify';
import axios from 'axios';
import {
  VAULTING_SERVICE_SINGLE_HYPERLINK_PATH,
  VAULTING_SERVICE_SINGLE_VAULT_REQUEST_PATH,
  VAULTING_SERVICE_VAULT_PATH,
  VAULTING_SERVICE_BUYER_RECORDS_PATH,
  VAULTING_SERVICE_SUPPLIER_RECORDS_PATH,
  VAULTING_SERVICE_CONTACT_LIST_SEARCH_PATH,
  VAULTING_SERVICE_VAULT_REQUEST_LIST_SEARCH_PATH,
  VAULTING_SERVICE_SINGLE_BUYER_CONTACT_PATH,
  VAULTING_SERVICE_CONTACTS_PATH,
  VAULTING_SERVICE_VAULT_REQUESTS_PATH,
  VAULTING_SERVICE_HYPERLINKS_PATH,
  VAULTING_SERVICE_USER_ACT_LIST_SEARCH_PATH,
  VAULTING_SERVICE_VAULT_ACT_LIST_SEARCH_PATH,
  VAULTING_SERVICE_SUPPLIER_SECRETS_PATH,
} from '../config/apiPath';
import { vaultingServiceUrl } from '../config/env';
import { replaceUUID } from './helperFunctions';

// Hyperlink

export const getHyperlinkByIdRequest = (uuid, locale, token) =>
  axios({
    method: 'get',
    url: replaceUUID(VAULTING_SERVICE_SINGLE_HYPERLINK_PATH, uuid),
    baseURL: vaultingServiceUrl,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': locale ?? 'en-US',
      'X-CSRF-TOKEN': token ?? '',
    },
  })
    .then((res) => res?.data)
    .catch((err) => {
      throw err;
    });

export const addNewHyperlinkRequest = (data, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_HYPERLINKS_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: data,
  }).catch((err) => {
    throw err;
  });

// Vault request

export const getVaultRequestByIdRequest = (uuid, locale, idToken) =>
  API.get(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SINGLE_VAULT_REQUEST_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
        'Accept-Language': locale ?? 'en-US',
      },
    },
  ).catch((err) => {
    throw err;
  });

export const deleteVaultRequestByIdRequest = (uuid, idToken) =>
  API.del(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SINGLE_VAULT_REQUEST_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
      },
      body: {},
    },
  ).catch((err) => {
    throw err;
  });

export const updateVaultRequestByIdRequest = (uuid, data, idToken) =>
  API.patch(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SINGLE_VAULT_REQUEST_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
      },
      body: data,
    },
  ).catch((err) => {
    throw err;
  });

export const addNewVaultRequest = (data, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_VAULT_REQUESTS_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: data,
  }).catch((err) => {
    throw err;
  });

// Vault Card

export const vaultCardRequest = (data, locale, token) =>
  axios({
    method: 'post',
    url: VAULTING_SERVICE_VAULT_PATH,
    baseURL: vaultingServiceUrl,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': locale ?? 'en-US',
      'X-CSRF-TOKEN': token ?? '',
    },
    data: {
      ...data,
    },
  })
    .then((res) => res?.data)
    .catch((err) => {
      throw err;
    });

// Buyer Contact

export const deleteBuyerContactByIdRequest = (uuid, idToken) =>
  API.del(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SINGLE_BUYER_CONTACT_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
      },
      body: {},
    },
  ).catch((err) => {
    throw err;
  });

export const addNewBuyerContactRequest = (data, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_CONTACTS_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: data,
  }).catch((err) => {
    throw err;
  });

export const updateBuyerContactByIdRequest = (uuid, data, idToken) =>
  API.patch(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SINGLE_BUYER_CONTACT_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
      },
      body: data,
    },
  ).catch((err) => {
    throw err;
  });

// Buyer Contact List

export const getBuyerContactListRequest = (contactSearchCriteria, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_CONTACT_LIST_SEARCH_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: contactSearchCriteria,
  }).catch((err) => {
    throw err;
  });

// Vault Request List

export const getVaultRequestListRequest = (
  vaultRequestSearchCriteria,
  idToken,
) =>
  API.post(
    'vaulting-portal-api',
    VAULTING_SERVICE_VAULT_REQUEST_LIST_SEARCH_PATH,
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
      },
      body: vaultRequestSearchCriteria,
    },
  ).catch((err) => {
    throw err;
  });

// Filtered Buyer Records

export const getFilteredBuyerRecordsRequest = (buyerName, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_BUYER_RECORDS_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: buyerName,
  }).catch((err) => {
    throw err;
  });
// Filtered Supplier Records

export const getFilteredSupplierRecordsRequest = (filterData, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_SUPPLIER_RECORDS_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: filterData,
  }).catch((err) => {
    throw err;
  });

// Filtered User Act List

export const getUserActListRequest = (userActSearchCriteria, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_USER_ACT_LIST_SEARCH_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: userActSearchCriteria,
  }).catch((err) => {
    throw err;
  });

// Filtered Vault Act List

export const getVaultActListRequest = (vaultActSearchCriteria, idToken) =>
  API.post('vaulting-portal-api', VAULTING_SERVICE_VAULT_ACT_LIST_SEARCH_PATH, {
    headers: {
      'X-COG-ID': idToken,
      'Content-Type': 'application/json',
    },
    body: vaultActSearchCriteria,
  }).catch((err) => {
    throw err;
  });

export const getSupplierSecretsRequest = (uuid, idToken) =>
  API.get(
    'vaulting-portal-api',
    replaceUUID(VAULTING_SERVICE_SUPPLIER_SECRETS_PATH, uuid),
    {
      headers: {
        'X-COG-ID': idToken,
        'Content-Type': 'application/json',
      },
    },
  ).catch((err) => {
    throw err;
  });
